// import { AppProvider } from './context/AppContext';
// import { MapProvider } from './context/MapContext';
import Tab from './component/tab/Tab';
import Content from './component/content/Content';
import SelectOption from './component/option/SelectOption';
import { useContext, useEffect } from 'react';
import { AppContext } from './context/AppContext';
import DataSourceModal from './component/modal/DataSourceModal';
import axios from 'axios';

function createVisitorLog() {
	axios({
		method: 'GET',
		url:
			process.env.REACT_APP_CONTEXT_PATH +
			'/interactive/api/visitor/log.json?item_cd=sph',
	});
}

function App() {
	const { dataSourceOpen } = useContext(AppContext);

	useEffect(() => {
		// createVisitorLog();
	}, []);

	return (
		<div className="App">
			<Tab />
			<SelectOption />
			<Content />
			{dataSourceOpen ? <DataSourceModal /> : null}
		</div>
	);
}

export default App;
